import { makeStyles } from '@material-ui/core';

export const useDialogStyles = makeStyles(theme => ({
  content: {
    padding: 0,
    minHeight: theme.spacing(62.5),
    display: 'flex'
  },
  actions: {
    padding: theme.spacing(1, 3, 2, 3),
    justifyContent: 'flex-end',
    '& > button:first-child': {
      marginRight: theme.spacing(1)
    }
  },
  mainContent: {
    flex: 1,
    padding: theme.spacing(0, 3)
  }
}));

export const useSidebarStyles = makeStyles(theme => ({
  sidebar: {
    width: theme.spacing(35),
    borderRight: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0, 2)
  },
  stepItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 1),
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    cursor: 'default',
    backgroundColor: 'transparent'
  },
  stepNumber: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    marginRight: theme.spacing(2),
    color: theme.palette.background.paper
  },
  activeStepNumber: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper
  },
  completedStepNumber: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper
  },
  inactiveStepNumber: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.background.paper
  },
  checkIcon: {
    fontSize: '1rem'
  },
  activeStepLabel: {
    color: theme.palette.text.primary,
    fontWeight: '500'
  },
  inactiveStepLabel: {
    color: theme.palette.text.secondary
  }
}));

export const useContentStyles = makeStyles(theme => ({
  stepContent: {
    minHeight: theme.spacing(37.5),
    display: 'flex',
    flexDirection: 'column'
  },
  formRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& > *': {
      flex: 1
    }
  },
  halfWidthField: {
    flex: `0 1 calc(50% - ${theme.spacing(1)}px)`
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium
  },
  addCriteriaButton: {
    alignSelf: 'flex-start',
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(1.5)
  },
  criteriaList: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  selectTaskMessage: {
    padding: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[300]}`
  },
  billingSection: {
    marginTop: theme.spacing(2)
  },
  summaryBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[300]}`
  },
  criteriaDescription: {
    marginTop: theme.spacing(1)
  },
  warningContainer: {
    width: '100%'
  },
  warningTitle: {
    fontWeight: theme.typography.fontWeightBold
  },
  fromLabel: {
    flex: 1
  },
  toLabel: {
    flex: 1
  },
  billingStatusLabel: {
    flex: 1
  },
  detailRow: {
    marginTop: theme.spacing(1),
    display: 'flex'
  },
  detailLabel: {
    flexShrink: 0,
    minWidth: '48px',
    marginRight: theme.spacing(1)
  }
}));
